import React, { useContext, useEffect, useState } from "react";
import Sidebar from "./sidebar";
import Header from "./header";
import { useDispatch, useSelector } from "react-redux";
import {
  addToRefundRequests,
  addToUserBusinesses,
} from "../redux/slices/businessSlice";
import {
  useGetMerchantBusinesses,
  useGetSubmerchantBusinesses,
} from "../api/services/businessServices";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { useVerifyUser } from "../api/services/authServices";
import { useGetMerchantRefunds } from "../api/services/ordersServices";
import { BusinessContext } from "../context/BusinessContext";
import Loader from "../components/Loader";

const DefaultLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState(pathname);
  useVerifyUser(currentPath);
  const queryClient = useQueryClient();
  useEffect(() => {
    setCurrentPath(pathname);
    queryClient.invalidateQueries(["verifyUser"]);
  }, [pathname]);

  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const [filters, setFilters] = useState({});

  const isMerchant = user?.type?.toLowerCase() === "merchant";

  const merchantBusinesses = useGetMerchantBusinesses(
    user?.id,
    filters,
    isMerchant
  );
  const submerchantBusinesses = useGetSubmerchantBusinesses(
    user?.id,
    !isMerchant
  );

  const {
    data: userBusinesses,
    isPending: isLoading,
    isError,
    error: getBusinessesError,
  } = isMerchant ? merchantBusinesses : submerchantBusinesses;
  // console.log("user businesses", userBusinesses)

  useEffect(() => {
    if (userBusinesses && !isLoading && !isError) {
      dispatch(addToUserBusinesses(userBusinesses));
    }
    if (
      !isLoading &&
      !isError &&
      Array.isArray(userBusinesses?.data) &&
      userBusinesses.data.length === 0 &&
      pathname !== "/dashboard/create-business"
    ) {
      navigate("/welcome", { replace: true });
    }
    if (
      !isLoading &&
      isError &&
      pathname !== "/dashboard/create-business"
    ) {
      navigate("/welcome", { replace: true });
    }
  }, [userBusinesses, isLoading, isError, dispatch, pathname, navigate]);

  const { activeBusiness } = useContext(BusinessContext);

  const {
    data: refunds,
    isPending: refundsLoading,
    error: getRefundsError,
  } = useGetMerchantRefunds(activeBusiness, filters);
  // console.log("Refunds", refunds)

  useEffect(() => {
    if (refunds && !refundsLoading && !getRefundsError) {
      dispatch(addToRefundRequests(refunds));
    }
  }, [refunds, getRefundsError]);

  if (isLoading) return <Loader />;

  return (
    <div>
      <div className="flex h-screen overflow-hidden">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          <main>
            <div className="mx-auto max-w-screen-2xl p-3.5 md:p-4">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
